import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { itTicketsAPI } from '../services/api';
import { ITTicketProblemType } from '../types';

interface ITTicketModalProps {
  visible: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

const ITTicketModal: React.FC<ITTicketModalProps> = ({ visible, onHide, onSuccess }) => {
  const [problemType, setProblemType] = useState<ITTicketProblemType | null>(null);
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const problemTypeOptions = [
    { label: 'Hardware', value: 'hardware' },
    { label: 'Software', value: 'software' },
    { label: 'Network', value: 'network' },
    { label: 'Printer', value: 'printer' },
    { label: 'Email', value: 'email' },
    { label: 'Password', value: 'password' },
    { label: 'Access', value: 'access' },
    { label: 'Other', value: 'other' }
  ];

  const handleSubmit = async () => {
    setError('');
    
    if (!problemType) {
      setError('Tip problema je obavezan');
      return;
    }
    
    if (!description.trim()) {
      setError('Opis problema je obavezan');
      return;
    }

    setLoading(true);
    try {
      await itTicketsAPI.create({
        problemType,
        description: description.trim()
      });
      setProblemType(null);
      setDescription('');
      onSuccess();
      onHide();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Greška pri kreiranju tiketa');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setProblemType(null);
    setDescription('');
    setError('');
    onHide();
  };

  return (
    <Dialog
      header="Prijavi IT problem"
      visible={visible}
      style={{ width: '500px' }}
      onHide={handleClose}
      footer={
        <div>
          <Button 
            label="Otkaži" 
            icon="pi pi-times" 
            onClick={handleClose} 
            className="p-button-text" 
            disabled={loading}
          />
          <Button 
            label="Pošalji" 
            icon="pi pi-check" 
            onClick={handleSubmit} 
            loading={loading}
          />
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {error && (
          <div style={{ padding: '0.75rem', backgroundColor: '#fee2e2', color: '#991b1b', borderRadius: '4px', fontSize: '0.875rem' }}>
            {error}
          </div>
        )}
        
        <div>
          <label htmlFor="problemType" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>
            Tip problema <span style={{ color: '#dc2626' }}>*</span>
          </label>
          <Dropdown
            id="problemType"
            value={problemType}
            options={problemTypeOptions}
            onChange={(e) => setProblemType(e.value)}
            appendTo="self"
            placeholder="Izaberite tip problema"
            style={{ width: '100%' }}
          />
        </div>

        <div>
          <label htmlFor="description" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>
            Opis problema <span style={{ color: '#dc2626' }}>*</span>
          </label>
          <InputTextarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Ukratko opišite problem..."
            rows={5}
            style={{ width: '100%' }}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ITTicketModal;



